export const toNumber = val =>  {
    const v = val === undefined ? 0 : val === null ? 0 : typeof val === 'number' ? Number(val.toFixed(2)) : Number.parseFloat(val.toString().replace(',', '.'))
    return isNaN(v) || !isFinite(v) ? 0 : v
}

export const sum = (a, b) => {
    a = toNumber(a)
    b = toNumber(b)
    return toNumber((a + b).toFixed(2))
}

export const sub = (a, b) => {
    a = toNumber(a)
    b = toNumber(b)
    return toNumber((a - b).toFixed(2))
}

export const mul = (a, b) => {
    a = toNumber(a)
    b = toNumber(b)
    return toNumber((a * b).toFixed(2))
}

export const div = (a, b) => {
    a = toNumber(a)
    b = toNumber(b)
    return toNumber((a / b).toFixed(2))
}
